import { render, staticRenderFns } from "./SelectBack5.vue?vue&type=template&id=237080eb&"
import script from "./SelectBack5.vue?vue&type=script&lang=js&"
export * from "./SelectBack5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports